// @flow

import React from 'react';

import ContentFooter from 'web-ssr/app/common/components/ContentFooter/ContentFooter';
import { HeaderContext } from 'web-ssr/app/common/components/ContentHeader/HeaderProvider';

type Props = {
  isDesignSystemFooter?: boolean,
};

const ContentFooterContainer = (props: Props) => {
  return (
    <HeaderContext.Consumer>
      {({ isLoggedIn }) => {
        return (
          <ContentFooter
            isDesignSystemFooter={props.isDesignSystemFooter}
            isLoggedIn={isLoggedIn}
          />
        );
      }}
    </HeaderContext.Consumer>
  );
};

export default ContentFooterContainer;
